import { render, staticRenderFns } from "./AddNewPlan.vue?vue&type=template&id=431d98a4&"
import script from "./AddNewPlan.vue?vue&type=script&lang=js&"
export * from "./AddNewPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports